import styled from "styled-components";

export const CardWrapper = styled.div`
width: ${(props) => (props.width)};
height: ${(props) => (props.height)};
border-radius: 8px;
background: #EAEEFC;
`

export const CardContent = styled.div`
padding: 16px;
`


export const MemberWrapper = styled.div`
height: 40px;
span{
    background: rgba(37, 85, 239, 0.20);
    display: flex;
    padding: 3px 12px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 6px;
    width: fit-content;
    height: 30px;
}
`

export const Title = styled.span`
color: #2555EF;
font-size: 13px;
font-style: normal;
font-weight: 500;
line-height: 32px;
`
export const AccountName = styled.span`
color: #2555EF;
font-size: 20.133px;
font-style: normal;
font-weight: bold;
line-height: 49.558px;
display: flex;
justify-content: left;
align-items: start;
height: 24px;
margin-bottom: 73px;
`

export const AccountId = styled.span`
display: flex;
width: 40px;
height: 24px;
flex-direction: column;
justify-content: center;
color: #2555EF;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 49.558px;
margin-bottom: 10px;
`

export const DescriptionWrapper = styled.div`
width: 100%;
display: flex;
justify-content: center;
align-items: center;
`
export const Desc = styled.span`
color: #525055;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 32px;
display: flex;
margin-top: 40px;

span{
font-size: 14px;
color: #002E5C;
padding-right: 10px;
padding-left: 10px;
border-bottom: 2px solid rgba(0, 46, 92, 1);
height: 30px; 
width: 182px;
text-overflow: ellipsis;
white-space: nowrap;
overflow: hidden;
text-align: center;
}
`

export const ExplainActions = styled.div`
display: flex;
padding: 24px 32px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 16px;
align-self: stretch;
background: rgba(37, 85, 239, 0.04);
margin-top: 20px;
margin-left: 40px;
margin-right: 40px;
div{

  line-height: 2;
  span{
    color: var(--dark-blue, #002E5C);
    font-size: 14px;
    font-style: normal;
    font-weight: bold;

  }
}
/* numbered list of what the merge will do */
> div:first-child span {
  font-weight: 300;
}
`
export const Note = styled.div`
width: 100%;
padding-left: 24px;
padding-right: 24px;
padding-top: 16px;
padding-bottom: 16px;
padding-right: 16px;
display: flex;
justify-content: center;
align-items: center;
border-radius: 4px;
border: 1px dashed rgba(37, 85, 239, 0.10);
background: rgba(37, 85, 239, 0.04);
span{
  padding-left: 12px;
  color: var(--blue, #2555EF) !important;
  font-size: 12px;
}
`
export const MergeInput = styled.div`
  display: flex;
  width: 91%;
  margin-top: 20px;
  margin-left: 40px;
  margin-right: 40px;
`